import { apiDelete, apiGet, apiPost, apiPut} from '@jumbo/utils/ApiHelper';
import config from 'config';
const loadApiUrl = config.loadApiUrl;
const apiUrl = config.apiUrl;
const carrierApiUrl = config.carrierApiUrl

export function getInterestSentUsersApi(data) {
  return apiGet(loadApiUrl, 'admin/lane/interests/users', data);
}

export function getLaneInterestsByUsersIdApi(user_id, data) {
  return apiGet(loadApiUrl, `admin/lane/interests/${user_id}`, data);
}

export function getCarrierDetailsByIdApi(carrier_id){
  return apiGet(carrierApiUrl, `admin/carriers/${carrier_id}`, {});
}

export function updateCarrierDetailsByIdApi(carrier_id, data){
  return apiPut(carrierApiUrl, `admin/carriers/${carrier_id}`, data);
}

export function sendShaTemplateByCarrierIdApi(carrier_id, data){
  return apiPut(carrierApiUrl, `admin/carriers/${carrier_id}/send_sha`, data);
}


export function getCarrierDetailsByUserIdApi(user_id){
  return apiGet(carrierApiUrl, `admin/users/${user_id}/carriers`, {});
}

export function getCommentsHistoryForCarrierApi(carrier_id, data){
  return apiGet(carrierApiUrl, `admin/users/${carrier_id}/comments`, data);
}

export function postCommentForCarrierApi(data, user_id){ 
  return apiPost(carrierApiUrl, `admin/users/${user_id}/comments`, data);
}

export function getQuestinnareForCarrierApi(carrier_id){ 
  return apiGet(carrierApiUrl, `admin/carriers/questionares/${carrier_id}`, {});
}

export function postQuestinnareForCarrierApi(data, carrier_id){
  return apiPut(carrierApiUrl, `admin/carriers/questionares/${carrier_id}`, data);
}

export function sendCarrierPacketApi(data){
  return apiPost(carrierApiUrl, `admin/carriers/send-packet?mc_number=${data.mc_number}&user_id=${data.user_id}`, {});
}

export function getOnboardingStatusUpdatesApi(carrier_id){ 
  return apiGet(carrierApiUrl, `admin/carrier/${carrier_id}/onboarding-updates`, {});
}

export function putOnboardingStatusUpdatesApi(data, carrier_id){
  return apiPut(carrierApiUrl, `admin/carrier/${carrier_id}/onboarding-updates`, data);
}

export function getShaTemplateApi(){
  return apiGet(apiUrl, `/admin/resources`);
}

export function getUserDetailsByIdApi(user_id){
  return apiGet(apiUrl, `/admin/api/users/${user_id}`);
}

export function fetchCarrierDocumentsApi(carrier_id){
  return apiGet(carrierApiUrl, `admin/carrier/${carrier_id}/documents`);
} 

export function updateComplianceForCarrierApi(carrier_id, data){
  return apiPut(carrierApiUrl, `admin/carriers/${carrier_id}`, data);
}

export function acceptOrRejectUserUploadedDocApi(document_id, data){
  return apiPut(carrierApiUrl, `admin/carrier/documents/${document_id}`, data);
} 

export function submitAdminUploadedDocsForCarrierApi(carrier_id, data){
  return apiPost(carrierApiUrl, `admin/carrier/${carrier_id}/documents-upload`, data);
} 

export function getCommentsForUserApi(user_id, data){
  return apiGet(carrierApiUrl, `admin/users/${user_id}/comments`, data);
}

export function addAdminCommentForDocRejectApi(user_id, data){
  return apiPost(carrierApiUrl, `admin/users/${user_id}/comments`, data);
}

export function deleteDocumentUploadedByAdminByIdApi(document_id){//removes from s3 and backend
  return apiDelete(carrierApiUrl, `admin/carrier/documents/${document_id}`);
}

export function deleteDocumentUploadedByAdminByNameApi(data){//use it only for removing any documents that are not saved in DB
  return apiDelete(carrierApiUrl, `admin/carrier/document/${data.document_name}`, data);
}

export function bulkUploadLanesApi(data){
  return apiPost(loadApiUrl, `admin/lanes`, data);
}

export function getAdminUploadedLanesWithFilterApi(data){
  return apiGet(loadApiUrl, `admin/lanes`, data);
}

export function fetchUserCommunicationHistoryApi(user_id){
  return apiGet(carrierApiUrl, `admin/users/${user_id}/communication`);
}

export function addUserCommunicationHistoryApi(user_id, data){
  return apiPost(carrierApiUrl, `admin/users/${user_id}/communication`, data);
}

export function updateUserCommunicationHistoryApi(communication_id, data){
  return apiPut(carrierApiUrl, `admin/users/communication/${communication_id}`, data)
}

export function getUserCarrierInfoFromExternalSourcesApi(user_id){
  return apiGet(carrierApiUrl, `admin/users/${user_id}/carrier-info`)
}

export function getCarrierLanePreferencesApi(carrier_id){
  return apiGet(carrierApiUrl, `admin/carriers/${carrier_id}/questionares/lanes`)
}

export function postCarrierLanePreferencesApi(carrier_id, data){
  return apiPost(carrierApiUrl, `admin/carriers/${carrier_id}/questionares/lanes`, data)
}

export function updateCarrierLanePreferencesApi(carrier_id, data){
  return apiPut(carrierApiUrl, `admin/carriers/${carrier_id}/questionares/lanes`, data)
}

export function deleteCarrierLanePreferencesApi(carrier_id, data){
  return apiDelete(carrierApiUrl, `admin/carriers/${carrier_id}/questionares/lanes`, data)
}